export type TDesignEditor = any;

export interface ISaveProductResponse {
  returnToEditUrl: string;
  stateId: string;
  userId: string;
};

export interface IProductItems {
  placeholderItems: Record<string, any>;
  boundedTextItems: Record<string, any>;
  plainTextItems: Record<string, any>;
};

export interface ICommandManager {
  execute: (command: string, options: { query: string, force: boolean }) => Promise<void>;
};

export type TVariableItems = Record<string, { name: string, type: string, value: string }[][] | { name: string, type: string, value: string }[]>;
export enum E_VARIABLE_SURFACE {
  DEFAULT = 'Page 1'
};